import _ from "underscore";
import baustein from "baustein";
import url from "web/script/utils/url";
import browser from "web/script/utils/browser";
import environment from "web/script/modules/environment";
import analytics from "web/script/analytics/analytics";
import facebookEvents from "web/script/analytics/facebook-events";
import doubleclickEvents from "web/script/analytics/doubleclick-events";
import globals from "web/script/modules/globals";

baustein.register("redirect-to-retailer", {
    defaultOptions: {
        isReturning: false,
        retailerName: "",
        redirectUrl: "",
        productId: "",
        originUrl: "",
        soldOutLead: false,
        returnUrl: "",
        minTimeout: 0,
        interstitialLink: false,
        salePrice: 0,
        isCssLead: false,
        retailerSlug: "",
        designerSlug: "",
        productCategory: "",
        productGender: "",
    },

    startTime: null,

    init: function() {
        var productId = this.options.productId;
        var category = this.options.isReturning ? "NAVIGATION" : "AFFILIATE";
        var getGAClientIDPromise = analytics.getGAClientID();
        var action = "LEAD";
        var urlParams = url.toURLSearchParams(globals.window.location.search);
        var onTrackingFinish = this._onTrackingFinish.bind(this);
        var promises;

        if (this.options.isReturning) {
            action = "RETAILER_BOUNCE";
        } else if (this.options.soldOutLead) {
            action = "LEAD_SOLD_OUT";
        }

        this.startTime = new Date().getTime();

        var redirectTimeout = setTimeout(function() {
            analytics.event(action, "timeout", productId, true);
        }, 10000);

        globals.window.addEventListener("unload", function(event) {
            if (event.target === globals.document) {
                clearTimeout(redirectTimeout);
            }
        });

        promises = [
            getGAClientIDPromise,
            analytics.event(category, action, this.options.productId, false, {
                sale_price: this.options.salePrice,
                isCssLead: this.options.isCssLead,
                retailer_slug: this.options.retailerSlug,
                designer_slug: this.options.designerSlug,
                category: this.options.productCategory,
                gender: this.options.productGender,
                product_id: productId,
                atc_grouping: urlParams.get("atc_grouping"),
            }),
            analytics.whenQueueIsEmpty(),
        ];

        if (!this.options.isReturning) {
            promises.push(
                analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents.LEAD, {}, true)
            );
            promises.push(
                analytics.tagEvent(
                    analytics.TAG_NETWORKS.DOUBLECLICK,
                    doubleclickEvents.AFFILIATE_LEAD,
                    {
                        atc_country: environment.get("country"),
                        atc_medium: urlParams.get("utc_medium"),
                        id: productId,
                    }
                )
            );

            var stockLead;
            if (this.options.soldOutLead) {
                stockLead = doubleclickEvents.AFFILIATE_OUT_OF_STOCK;
            } else {
                stockLead = doubleclickEvents.AFFILIATE_IN_STOCK;
            }
            promises.push(
                analytics.tagEvent(analytics.TAG_NETWORKS.DOUBLECLICK, stockLead, { id: productId })
            );

            if (browser.supportsHistory) {
                this._updateHistoryState();
            }
        }

        // wait up to 3 seconds for analytics to finish
        let analyticsTimeout = setTimeout(() => {
            onTrackingFinish(null);
        }, 3000);

        // we want to redirect here even if the analytics stuff fails
        Promise.all(promises)
            .then(onTrackingFinish)
            .then(() => {
                clearTimeout(analyticsTimeout);
            })
            .catch(() => {
                clearTimeout(analyticsTimeout);

                // explicitly pass null here as we won't want whatever error
                // gets passed to this handler to be confused with the client id
                onTrackingFinish(null);
            });

        // as soon as we have the client id we have to update the link and the meta refresh
        // fallback so we don't lose it when it kicks in
        if (!this.options.isReturning) {
            getGAClientIDPromise.then(this._updateFallbackUrls.bind(this));
        }
    },

    /**
     * This function will be called when the tracking promises are all resolved or if they fail.
     * Because it handles both success and error cases it may receive a list of values or null.
     * @param values
     * @private
     */
    _onTrackingFinish: function(values) {
        var clientId = _.isArray(values) ? values[0] : null;
        if (!_.isString(clientId)) {
            clientId = null;
        }
        this._doRedirect(clientId);
    },

    _doRedirect: function(clientId) {
        if (!this.options.redirectUrl) {
            return;
        }

        // if user is coming back and we have a url for the product page send them there
        if (this.options.isReturning && this.options.originUrl) {
            if (globals.window.opener || this.options.interstitialLink) {
                globals.window.close();
            } else {
                globals.window.location = this.options.originUrl;
            }

            return;
        }

        var endTime = new Date().getTime();
        var timeDiff = (endTime - this.startTime) / 1000;
        if (timeDiff < this.options.minTimeout) {
            var newTimeout = this.options.minTimeout * 1000 - (endTime - this.startTime);
            globals.window.setTimeout(this._redirect.bind(this, clientId), newTimeout);
        } else {
            this._redirect(clientId);
        }
    },

    _redirect: function(clientId) {
        globals.window.location = this._getClientIdUrl(clientId);
    },

    _getClientIdUrl: function(clientId) {
        var parsed = url.parse(this.options.redirectUrl);
        parsed.searchParams.set("client_id", clientId);
        return url.unparse(parsed);
    },

    _updateFallbackUrls: function(clientId) {
        const redirectUrl = this._getClientIdUrl(clientId);

        const metaRefresh = document.querySelector("[data-meta-refresh]");
        const fallbackLink = this.el.querySelector("[data-fallback-link]");

        if (metaRefresh) {
            metaRefresh.content = `3;url=${redirectUrl}`;
        }

        if (fallbackLink) {
            fallbackLink.href = redirectUrl;
        }
    },

    /**
     * Function used to determine the behaviour of the back button from the retailer page.
     */
    _updateHistoryState: function() {
        var urlParams = url.toURLSearchParams(globals.window.location.search);
        if (["Google-PLA-CSS", "Bing-PLA"].indexOf(urlParams.get("atc_grouping")) > -1) {
            // PAID-1170
            // Instead of pushing the return redirect url to the history stack, update the
            // most recent entry with the origin url.
            // This should remedy the confusing back button behaviour that has caused users
            // to get stuck on this page when hitting the back button.
            //
            // Also persist existing query param values to ensure that it is tracked
            // as CSS activity in analytics.
            var replaceUrl = this.options.originUrl + globals.window.location.search;
            window.history.replaceState(null, document.title, replaceUrl);
        } else {
            // 1. Do it twice, because... chrome bug (when going back it seems to
            //    skip over the first page)
            // 2. Need to use the actual history API here and not our internal wrapper
            //    module as that actually prevents the creation of duplicate history entries.
            window.history.pushState(null, document.title, this.options.returnUrl);
            window.history.pushState(null, document.title, this.options.returnUrl);
        }
    },
});
